import React from "react";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { baseURL } from "../../Config/config";
import EditIcon from "@mui/icons-material/Edit";
import { makeStyles } from "@mui/styles";
import Projectcolors from "../../Utils/Colors";

const useStyles = makeStyles(() => ({
  disableRipple: {
    "&:hover": {
      backgroundColor: "transparent",
    },
    borderRadius: "3px",
  },
}));

const ShareProjectModal = (props) => {



  const navigate = useNavigate();

  const [isLoading, setIsLoading] = React.useState(false);

  

  const buttonStatus = !props.email ? true : false;
  const classes = useStyles();

  return (
  <Modal
    open={props.isModal}
    onClose={props.toggleModal}
    aria-labelledby="modal-modal-title"
  >
    <Box
      sx={{
        width: 380,
        bgcolor: "#fff",
        borderRadius: "22px",
        p: 3,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        boxShadow: "0px 12px 40px rgba(0,0,0,.15)",
        border: "1px solid #d9e9f7",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 700,
          color: "#0078c9",
          mb: 0.5,
        }}
      >
        Share Project
      </Typography>

      <Typography sx={{ fontSize: "12px", color: "#666", mb: 2 }}>
        Enter user email and choose access type.
      </Typography>

      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 600,
          color: "#444",
          mb: 0.6,
        }}
      >
        Email Address
      </Typography>

      <TextField
        fullWidth
        size="small"
        variant="outlined"
        placeholder="Email"
        onChange={(e) => props.setEmail(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            fontSize: "14px",
            height: 40,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#d9e9f7",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#9e0b22",
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0078c9",
          },
        }}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 1,
          mt: 2.5,
        }}
      >
        <Button
          disabled={buttonStatus}
          onClick={() => props.handleShareProject(false)}
          variant="outlined"
          sx={{
            height: 38,
            px: 2,
            fontSize: "12px",
            fontWeight: 600,
            borderRadius: "12px",
            textTransform: "none",
            color: "#0078c9",
            borderColor: "#0078c9",

            "&:hover": {
              borderColor: "#9e0b22",
              color: "#9e0b22",
              bgcolor: "#fff",
            },
          }}
        >
          Read Only
        </Button>

        <Button
          disabled={buttonStatus}
          onClick={() => props.handleShareProject(true)}
          variant="contained"
          sx={{
            height: 38,
            px: 2,
            fontSize: "12px",
            fontWeight: 600,
            color:"#fff",
            borderRadius: "12px",
            textTransform: "none",
            background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
            boxShadow: "0px 8px 18px rgba(0,120,201,.25)",

            "&:hover": {
              background: "#9e0b22",
            },
          }}
        >
          Edit Access
        </Button>
      </Box>
    </Box>
  </Modal>
);
};

export default ShareProjectModal;
